import React, { Component } from 'react';
import styles from './styles.scss';
import { number, arrayOf, shape, string, oneOfType, func, bool } from 'prop-types';
import classnames from 'classnames';
import { isNumber } from 'lodash';

export default class GeoTableRow extends Component {
  static propTypes = {
    data: shape({
      name: string,
      visits: number,
      ads: number,
      visitsOfAds: string,
      avgAdCost: number,
      sumAvgAdCost: number,
      criterial_id: oneOfType([number, string])
    }),
    onClick: func,
    isAvgCostDisabled: bool,
    isCustomReport: bool,
  };

  static defaultProps = {
    data: {}
  };

 render() {
   const { isAvgCostDisabled, data, onClick, isCustomReport } = this.props;
   const { name, visits, ads, visitsOfAds, avgAdCost, criterial_id, isUnrated, isLastNode, isDisableLocationName } = data;
   const formattedAdVisit = parseFloat(visits.toFixed(1));
   const visitsPerAd = isNumber(visitsOfAds) ? parseFloat(visitsOfAds.toFixed(2)) : 'N/A';
   const formattedAvgAdCost = avgAdCost === null || avgAdCost === 'N/A' ? 'N/A' : `$${avgAdCost.toFixed(2).toLocaleString()}`;
   const formattedName = isUnrated? `${name} (Unrated)`: name;
   const tableCellClasses = isCustomReport ? classnames(styles.tableCell, styles.customTableCell) : styles.tableCell;

   return (
    <div data-test="geoTableRow" className={styles.tableRow} key={criterial_id}>
      <div
        data-test="geoTableName"
        className={classnames(styles.tableCell, styles.locationName, {[styles.locationLastChild] : isLastNode || isDisableLocationName})}
        key='name'
        onClick={onClick(data, true)}
      >
        {formattedName}
      </div>
      <div data-test="geoTableAdVisits" className={tableCellClasses} key='visits' onClick={onClick(data)}>{formattedAdVisit.toLocaleString()}</div>
      <div data-test="geoTableAds" className={tableCellClasses} key='ads' onClick={onClick(data)}>{ads.toLocaleString()}</div>
      <div data-test="geoTableAdvisitsAds" className={tableCellClasses} key='visitsOfAds' onClick={onClick(data)}>{visitsPerAd.toLocaleString()}</div>
      {
        !isAvgCostDisabled &&
        <div data-test="geoTableAvgAdCost" className={tableCellClasses} key='avgAdCost' onClick={onClick(data)}>{formattedAvgAdCost}</div>
      }
    </div>
   )
 }
};
